// Copyright ©️ 2026 eVolve MEP, LLC

import * as THREE from 'three';

import type { HighlightableObjectName } from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/Labels/HighlightableGroup';
import { labelTheming } from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/Labels/labelTheming';
import { MarkedMeasurementLineGeometry } from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/Labels/MarkedMeasurementLineGeometry';
import type { MeasurementGeometryOpts } from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/Labels/MeasurementGeometry';

/**
 * Simple subclass of MarkedMeasurementLineGeometry for connector lines, which connect the endpoints of two or more leader lines.
 * Hidden initially since its correct coordinates are calculated later and provided using `update`.
 **/
export class ConnectorLineGeometry extends MarkedMeasurementLineGeometry {
  constructor(highlightableObjectName: HighlightableObjectName, layer?: MeasurementGeometryOpts['layer']) {
    super(highlightableObjectName, {
      start: new THREE.Vector3(),
      /** Offset X slightly to avoid degenerate geometry */
      end: new THREE.Vector3(0.001, 0, 0),
      lineType: 'dimensionLine',
      markerType: 'arrow',
      renderOrder: labelTheming.renderOrder.connectorLine,
      layer,
    });
    this.hide();
  }
}
